import { render } from "./FeaturedExpert.vue?vue&type=template&id=883d7934"
import script from "./FeaturedExpert.vue?vue&type=script&lang=js"
export * from "./FeaturedExpert.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__